import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ShipmentCommonModel } from '@well/delivery-libs/shipment/domain';
import { ShipmentCommonStore } from './shipment-common.store';

@Injectable({
  providedIn: 'root',
})
export class ShipmentCommonStoreFacadeService {
  private store = inject(ShipmentCommonStore);

  // Signal API (new)
  readonly shipmentCommonModel = this.store.shipmentCommonModel;
  readonly orderShipmentsUuids = this.store.orderShipmentsUuids;

  // Observable API (backward compatible)
  readonly shipmentCommonModel$ = toObservable(this.store.shipmentCommonModel);

  updateShipmentCommonModel(shipmentCommonModel: ShipmentCommonModel): void {
    this.store.updateShipmentCommonModel(shipmentCommonModel);
  }

  getShipmentCommonModel() {
    return this.shipmentCommonModel$;
  }

  clearShipmentCommonModel(): void {
    this.store.clearShipmentCommonModel();
  }
}
